var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50011 11.22C12.5401 16.4 20.0001 26 20.0001 26V38C20.0001 39.1 20.9001 40 22.0001 40H26.0001C27.1001 40 28.0001 39.1 28.0001 38V26C28.0001 26 35.4401 16.4 39.4801 11.22C40.5001 9.9 39.5601 8 37.9001 8H10.0801C8.42011 8 7.48011 9.9 8.50011 11.22Z",
    fill: "url(#paint0_linear_189_1418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_1418",
    x1: 23.9901,
    y1: 8,
    x2: 23.9901,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8B126"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOut);
export default __webpack_public_path__ + "static/media/filter-out.74d10c56.svg";
export { ForwardRef as ReactComponent };